import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    DateInput,
    required,
    useNotify,
    useCreate,
    useRedirect,
    useResourceContext,
    TopToolbar,
} from 'react-admin';
import SnInput from '../../Components/SnInput';
import BackButton from '../../Components/BackButton';

const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);

const validateSnList = (value: string) => {
    if (!value) return undefined;

    // 检查是否包含除了中英文逗号以外的其他标点符号
    const invalidPunctuation = /[!@#$%^&*()_+\-=\[\]{};':"\\|<>?/~`！@#￥%……&*（）——+=\[\]{}；'："\\|《》？～·]/;

    if (invalidPunctuation.test(value)) {
        return 'SN列表只能使用中英文逗号分隔，不能包含其他标点符号';
    }

    return undefined;
};


export const storeProductCreate = () => {
    const notify = useNotify();
    const [create] = useCreate();
    const redirect = useRedirect();
    const resource = useResourceContext();

    // 验证生产日期是否超过当前时间
    const validateProductionDate = (value: any) => {
        if (!value) {
            return '生产日期是必填项';
        }

        const productionDate = new Date(value);
        const currentDate = new Date();

        // 设置时间为0，只比较日期部分
        productionDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        // 如果生产日期晚于当前日期
        if (productionDate > currentDate) {
            return '生产日期不能晚于当前系统日期';
        }

        return undefined; // 验证通过
    };

    const handleSubmit = (data: any) => {
        // 先验证生产日期
        const productionDateError = validateProductionDate(data.productionDate);
        if (productionDateError) {
            notify(productionDateError, { type: 'error' });
            return Promise.reject(new Error(productionDateError));
        }

        const snsString = data.sns || '';
        const snsArray = snsString
            .split(/[,，]+/) // 支持中英文逗号分隔
            .map(sn => sn.trim())
            .filter(Boolean);

        if (snsArray.length === 0) {
            notify('请输入至少一个设备SN', { type: 'error' });
            return Promise.reject();
        }

        return create(
            'storeProduct',
            { data: { ...data, sns: snsArray } },
            {
                onSuccess: (data) => {
                    notify(`产品入库成功!`, {
                        type: 'success',
                        autoHideDuration: 3000,
                    });
                    redirect('list', resource);
                },
                onError: (error) => {
                    console.error('创建失败:', error);
                    notify(`入库失败: ${error.message || '服务器错误'}`, {
                        type: 'error',
                        autoHideDuration: 3000,
                    });
                }
            }
        );
    };

    return (
        <Create actions={<ActionsToolbar />}>
            <SimpleForm sx={{ width: { lg: '40%', xs: '100%' } }} onSubmit={handleSubmit}>
                <SnInput
                    source="sns"
                    label="设备SN"
                    validate={[required(), validateSnList]}
                    helperText="多个序列号请用逗号分隔，在英文输入法下扫条码"
                />
                <DateInput
                    label="生产日期"
                    source="productionDate"
                    validate={[required(), validateProductionDate]}
                    // 设置最大日期为今天
                    maxDate={new Date().toISOString().split('T')[0]}
                />
                {/* <TextInput label="备注" source="remark" fullWidth /> */}
            </SimpleForm>
        </Create>
    )
};